import { render, staticRenderFns } from "./PaymentRecord.vue?vue&type=template&id=916c7c36&scoped=true&"
import script from "./PaymentRecord.vue?vue&type=script&lang=js&"
export * from "./PaymentRecord.vue?vue&type=script&lang=js&"
import style0 from "./PaymentRecord.vue?vue&type=style&index=0&id=916c7c36&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "916c7c36",
  null
  
)

export default component.exports